module.exports = __webpack_public_path__ + "2672b46062cc26b2f5b0d5b6bbacb2a3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/up-21.png
// module id = 2633
// module chunks = 0